<app-header></app-header>
<div class="responsive">
    <div class="container-fluid">



        <div class="row">
            <div class="col-md-3">
                <app-sidebar></app-sidebar>
            </div>
            <div class="col-md-6">

                <div class="container">
                    <div class="row">
                        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                            <app-sub-header title="Create Alert"></app-sub-header>





                            <form [formGroup]="form" (ngSubmit)="onSubmit()" autocomplete="off">
                                <div style="min-height: 500px;">

                                    <div class="display margin-b ">
                                        <div class="header cursor " [ngClass]="{'active':activeTab === 'general'}"
                                            (click)="getScrollTo('general')" id="general">General
                                        </div>
                                        <div class="header cursor"
                                            [ngClass]="{'activeSecond':activeTab === 'important'}"
                                            (click)="getScrollTo('important')" id="important">Important
                                        </div>
                                        <div class="header cursor" [ngClass]="{'activeThird':activeTab === 'urgent'}"
                                            (click)="getScrollTo('urgent')" id="urgent">Urgent
                                        </div>

                                    </div>

                                    <div class="row">
                                        <div class="col-md-12">
                                            <div class="form-group">
                                                <!-- <label for="comment">Alert Title</label> -->
                                                <textarea class="form-control" formControlName="name"
                                                    placeholder="Alert Title" rows="2"
                                                    [ngClass]="{ 'is-invalid': submitted && f.name.errors }">
                                                   </textarea>
                                                <div *ngIf="submitted && f.name.errors" class="invalid-feedback">
                                                    <div style="text-align: right;" *ngIf="f.name.errors.required">
                                                        {{errorMessage}}</div>
                                                </div>
                                            </div>
                                        </div>

                                    </div>

                                    <div class="row">
                                        <div class="col-md-12">
                                            <div class="form-group">
                                                <!-- <label for="comment">Description</label> -->
                                                <textarea maxlength="250" class="form-control"
                                                    formControlName="description" placeholder="Description" rows="5"
                                                    [ngClass]="{ 'is-invalid': submitted && f.description.errors }"></textarea>
                                                <div style="text-align: right;" class="margin-b">
                                                    <p style="margin-bottom: -1rem;" class="small error">
                                                        {{f.description.value?.length || 0}}/250</p>
                                                </div>
                                                <div *ngIf="submitted && f.description.errors" class="invalid-feedback">
                                                    <div style="text-align: right;"
                                                        *ngIf="f.description.errors.required">{{errorMessage}}</div>
                                                </div>



                                            </div>
                                        </div>

                                    </div>

                                    <div class="row">
                                        <div class="col-md-12">
                                            <div class="form-group">
                                                <input type="text" class="form-control" formControlName="link"
                                                    placeholder="Link(optional)" [value] = "checkUrl(form.get('link').value)"
                                                    [ngClass]="{ 'is-invalid': submitted && f.link.errors }">

                                                <div *ngIf="submitted && f.link.errors" class="invalid-feedback">
                                                    <div style="text-align: right;" *ngIf="f.link.errors.pattern">
                                                        {{"Please enter valid url"}}</div>
                                                </div>

                                            </div>
                                        </div>

                                    </div>
                                </div>

                                <br>
                                <button type="submit"
                                    class="btn btn-lg color btn-block main-backgroundcolor">Send</button>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-3">
                <app-events [showheader]=true></app-events>

            </div>
        </div>
    </div>
</div>
